import React, { ComponentPropsWithoutRef } from "react";

import Icon from "../Icons";
import { HelperText, ErrorText, Label } from "./FormCopy";

export interface SelectOption {
  value: string | number | undefined;
  label: string | null;
}
export type selectInputProps = ComponentPropsWithoutRef<"select">;
export const SelectField = ({
  formProps,
  label,
  helpText,
  errorMessage,
  options,
  ...props
}: {
  formProps?: NotTypedYet;
  label: React.ReactNode;
  helpText?: React.ReactNode;
  errorMessage?: React.ReactNode;
  options: SelectOption[];
  name: string;
  onChange?: (newValue: React.ChangeEvent<HTMLSelectElement>) => void;
} & selectInputProps) => {
  const { register, errors } = formProps || {};
  return (
    <div className="space-y-12">
      {(label || helpText) && (
        <div>
          <Label htmlFor={undefined}>{label}</Label>
          <HelperText> {helpText}</HelperText>
        </div>
      )}
      <div>
        <SelectInput
          children={undefined}
          register={register}
          options={options}
          {...props}
        />
        {errors && (
          <ErrorText inError={errors[props.name]}>
            {errors[props.name] && errors[props.name].message}
          </ErrorText>
        )}
      </div>
    </div>
  );
};

export const SelectInput = ({
  options,
  register,
  children,
  ...props
}: {
  options: SelectOption[];
  register?: NotTypedYet;
  children?: React.ReactNode;
  className?: string;
} & selectInputProps) => {
  return (
    <div className="relative">
      <select
        className="focus:outline-none bg-white focus:ring border-2 border-primary-100 rounded py-8 pl-16 pr-32 block w-full appearance-none leading-normal"
        ref={register}
        {...props}
      >
        {children ||
          options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
      </select>

      <div className="pointer-events-none absolute inset-y-0 right-0 items-center flex px-8 text-neutral-600">
        <Icon
          size="xl"
          key="expandMore"
          icon="expandMore"
          className={undefined}
        />
      </div>
    </div>
  );
};

SelectInput.Unstyled = ({
  options,
  formProps: { register },
  className,
  children,
  ...props
}: selectInputProps & {
  options: SelectOption[];
  formProps: NotTypedYet;
  className?: string;
  children?: React.ReactNode;
  disabled?: boolean;
}) => {
  return (
    <div className="relative h-full">
      <select
        className={`${className} pr-16 w-full block appearance-none`}
        ref={register()}
        {...props}
      >
        {children ||
          options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
      </select>

      {!props.disabled && (
        <div className="pointer-events-none absolute inset-y-0 right-0 items-center flex px-4 ">
          <Icon size="xl" key="expandMore" icon="expandMore" color="current" />
        </div>
      )}
    </div>
  );
};

export default SelectField;
